<dx-popup
  [(visible)]="showModal"
  [width]="'90%'"
  [maxWidth]="950"
  [height]="'auto'"
  [showTitle]="false"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  [wrapperAttr]="{ 
    class: 'subscription-settings-popup' 
  }"
>
  <div 
    *dxTemplate="let data of 'content'" 
    class="subscription-popup"
  >
    <div class="popup-header">
      <div>
        <div class="popup-kicker">
          {{ 'SUBSCRIPTION-SETTINGS.OVERVIEW.TITLE' | translate }}
        </div>
        <div class="popup-title">
          {{ title }}
        </div>
      </div>

      <dx-button
        icon="close"
        type="default"
        (onClick)="close()"
        [elementAttr]="{ 
          class: 'close-button' 
        }"
      ></dx-button>
    </div>

    <dx-scroll-view class="popup-content" [height]="'72vh'">
      <div class="popup-content-header" *ngIf="isLoaded">
        <div
          class="popup-description"
          [innerHTML]="overviewTranslationKey | translate">
        </div>

        <div class="summary" *ngIf="attentionProviders.length">
          <div class="summary-content">
            <div class="summary-card success">
              <div class="summary-number">
                {{ matchedProviders.length }}
              </div>

              <div>
                {{ 'SUBSCRIPTION-SETTINGS.OVERVIEW.MATCHED' | translate }}
              </div>
            </div>

            <div class="summary-divider"></div>

            <div class="summary-card warning">
              <div class="summary-number">
                {{ attentionProviders.length }}
              </div>

              <div>
                {{ 'SUBSCRIPTION-SETTINGS.OVERVIEW.NEED-YOUR-ATTENTION' | translate }}
              </div>
            </div>
          </div>

          <div class="summary-progress">
            <dx-progress-bar
              [min]="0"
              [max]="matchedProviders.length + attentionProviders.length"
              [value]="matchedProviders.length">
            </dx-progress-bar>
          </div>
        </div>
      </div>

      <div class="section" *ngIf="attentionProviders.length">
        <div class="section-title warning">
          <i 
            class="dx-icon dx-svg-icon summary-icon warning" 
            [innerHTML]="getWarningIcon()"
          ></i>

          {{ 'SUBSCRIPTION-SETTINGS.NEEDS-YOUR-ATTENTION.TITLE' | translate }}

          <span class="section-count">
            {{ attentionProviders.length }}
          </span>
        </div>
        <div class="attention-separator">
          <hr />
        </div>

        <div
          class="attention-row warning"
          *ngFor="let item of attentionProviders"
        >
          <div class="left">
            <div class="publisher-category">
             {{ item.publisherStandardCategory.name }}
            </div>

            <div class="subtitle">
              {{ 'SUBSCRIPTION-SETTINGS.NEEDS-YOUR-ATTENTION.NO-STANDARD-MATCH' | translate }}
            </div>
          </div>

          <div class="right">
            <dx-drop-down-box
              #trainingCategoryDropDown
              [value]="getConsumerTrainingCategoryIds(item)"
              valueExpr="trainingCategory.id"
              displayExpr="trainingCategory.name"
              [dataSource]="trainingCategories"
              [showClearButton]="false"
              [width]="275"
              labelMode="floating"
              stylingMode="outlined"
              [placeholder]="
                'SUBSCRIPTION-SETTINGS.NEEDS-YOUR-ATTENTION.LINK-TO-YOUR-CATEGORY'
                  | translate
              "
              [dropDownOptions]="{ minHeight: 400 }"
              [elementAttr]="{ 
                class: 'subscription-category-dropdown' 
              }"
            >
              <div 
                *dxTemplate="let data of 'content'" 
                class="dropdown-content"
              >
                <dx-tree-view
                  #trainingCategoryTree
                  [dataSource]="trainingCategories"
                  keyExpr="trainingCategory.id"
                  displayExpr="trainingCategory.name"
                  [searchEnabled]="true"
                  selectionMode="multiple"
                  showCheckBoxesMode="normal"
                  [height]="350"
                  [selectNodesRecursive]="false"
                  [selectByClick]="true"
                  (onSelectionChanged)="onSelectionChanged($event)"
                ></dx-tree-view>

                <div class="dropdown-footer">
                  <dx-button
                    [text]="'COMMON.APPLY' | translate"
                    type="normal"
                    (onClick)="
                      applySelection(item, trainingCategoryDropDown, trainingCategoryTree)
                    "
                  ></dx-button>

                  <dx-button
                    [text]="'COMMON.CANCEL' | translate"
                    type="default"
                    (onClick)="
                      cancelSelection(trainingCategoryDropDown, trainingCategoryTree)
                    "
                  ></dx-button>
                </div>
              </div>
            </dx-drop-down-box>

            <dx-button
              [text]="'SUBSCRIPTION-SETTINGS.OVERVIEW.ADD-FROM-STANDARD' | translate"
              icon="plus"
              type="default"
              stylingMode="outlined"
              [elementAttr]="{ 
                class: 'active-button' 
              }"
              (onClick)="addFromStandard(item)"
            ></dx-button>

            <dx-button
              [text]="'COMMON.SKIP' | translate"
              (onClick)="skipProviderCategory(item)"
              type="text"
              stylingMode="text"
              [elementAttr]="{ 
                class: 'muted-button' 
              }"
            ></dx-button>
          </div>
        </div>
      </div>

      <div class="section" *ngIf="matchedProviders.length">
        <div class="section-title">
          <i 
            class="dx-icon dx-svg-icon summary-icon success" 
            [innerHTML]="getCheckIcon()"
          ></i>

          {{ 'SUBSCRIPTION-SETTINGS.MATCHED.TITLE' | translate }}

          <span class="section-count">
            {{ matchedProviders.length }}
          </span>
        </div>

        <div class="category-separator">
          <hr />
        </div>

        <div class="section-description">
          {{ 'SUBSCRIPTION-SETTINGS.MATCHED.DESCRIPTION' | translate }}
        </div>

        <div
          class="matched-row"
          *ngFor="let item of matchedProviders"
          [class.disabled]="!item.enabled"
        >
          <div class="row-main">
            <div class="row-content">
              <div class="category-pair">
                <div class="category-name">
                  <div class="publisher-category">
                    {{ item.publisherStandardCategory.name }}
                  </div>

                  <i class="dx-icon dx-icon-arrowright"></i>

                  <div class="my-category">
                    @if (isAutoMatched(item)) {
                      @let consumerCategory = item.consumerTrainingCategories[0];

                      @if (consumerCategory.standardTrainingCategoryId) {
                        {{ item.publisherStandardCategory.name }}
                      } @else {
                        {{ consumerCategory.name }}
                      }
                    } 
                    @else {
                      <dx-drop-down-box
                        #matchedTrainingCategoryDropDown
                        [value]="getConsumerTrainingCategoryIds(item)"
                        valueExpr="trainingCategory.id"
                        displayExpr="trainingCategory.name"
                        [dataSource]="trainingCategories"
                        [showClearButton]="false"
                        [width]="400"
                        stylingMode="outlined"
                        [dropDownOptions]="{ minHeight: 400 }"
                      >
                        <div *dxTemplate="let data of 'content'">
                          <dx-tree-view
                            [dataSource]="trainingCategories"
                            keyExpr="trainingCategory.id"
                            displayExpr="trainingCategory.name"
                            [searchEnabled]="true"
                            selectionMode="multiple"
                            showCheckBoxesMode="normal"
                            [height]="350"
                            [selectNodesRecursive]="false"
                            [selectByClick]="true"
                            (onSelectionChanged)="
                              onTrainingCategoriesChanged(item, $event)
                            "
                            (onInitialized)="initTree($event, item)"
                          ></dx-tree-view>
                        </div>
                      </dx-drop-down-box>
                    }
                  </div>

                </div>
                @if(isAutoMatched(item)) {
                   @let consumerCategory = item.consumerTrainingCategories[0];

                  <span 
                    *ngIf="consumerCategory.standardTrainingCategoryId"
                    class="category-origin-badge category-origin-badge-standard"
                  >
                    <i
                      class="dx-icon dx-svg-icon"
                      [innerHTML]="getLockIcon()">
                    </i>
                    {{ 'COMMON.STANDARD' | translate }}
                  </span>

                  <span 
                    *ngIf="consumerCategory.associatedStandardTrainingCategoryId"
                    class="category-origin-badge category-origin-badge-associated"
                  >
                    <i
                      class="dx-icon dx-svg-icon"
                      [innerHTML]="getStarIcon()">
                    </i>
                    <span class="via-category">{{ 'COMMON.VIA' | translate }}</span>
                    {{ ' ' + (item.publisherStandardCategory.name) }}
                  </span>
                }
              </div>

              <div 
                class="groups-container"
                *ngIf="item.consumerTrainingGroups?.length"
              >
                <i 
                  class="dx-icon dx-svg-icon" 
                  [innerHTML]="getUsersIcon()"
                ></i>

                <div class="groups">
                  <div class="group" *ngFor="let group of item.consumerTrainingGroups">
                    {{ group.name }}
                  </div>
                </div>

                <div class="from-category">
                  {{ 'SUBSCRIPTION-SETTINGS.MATCHED.FROM-CATEGORY' | translate }}
                </div>
              </div>
            </div>

            <div class="row-actions">
              <div class="auto-mapped" *ngIf="isAutoMatched(item)">
                @if(item.enabled) {
                  <span class="auto-label">
                    <i 
                      class="dx-icon dx-svg-icon" 
                      [innerHTML]="getStarIcon()"
                    ></i>

                    <span class="auto-label-text">
                      {{ 'COMMON.AUTO' | translate }}
                    </span>
                  </span>
                } @else {
                  <span class="not-imported-label">
                    {{ 'COMMON.NOT-IMPORTED' | translate }}
                  </span>
                }
              </div>

              <dx-button
                *ngIf="!isAutoMatched(item)"
                icon="revert"
                type="default"
                [text]="'COMMON.UNMATCH' | translate"
                [elementAttr]="{ 
                  class: 'muted-button' 
                }"
                (onClick)="unmatchCategory(item)">
              </dx-button>
              
              <mat-slide-toggle
                [(ngModel)]="item.enabled"
                class="req-toggle"
              ></mat-slide-toggle>
            </div>
          </div>
        </div>
      </div>

      <div class="section" *ngIf="unmatchedProviders.length">
        <div class="section-title">
          <i
            class="dx-icon dx-svg-icon summary-icon danger"
            [innerHTML]="getCloseIcon()">
          </i>

          {{ 'SUBSCRIPTION-SETTINGS.UNMATCHED.TITLE' | translate }}

          <span class="section-count">
            {{ unmatchedProviders.length }}
          </span>
        </div>

        <div class="category-separator">
          <hr />
        </div>

        <div class="section-description">
          {{ 'SUBSCRIPTION-SETTINGS.UNMATCHED.DESCRIPTION' | translate }}
        </div>

       <div 
        class="unmatched-row disabled" 
        *ngFor="let item of unmatchedProviders"
       >
          <div class="row-main">
            <div class="row-content">
              <div class="publisher-category">
                {{ item.publisherStandardCategory.name }}
              </div>
            </div>

            <div class="row-actions">
              <span class="not-imported-label">
                {{ 'COMMON.NOT-IMPORTED' | translate }}
              </span>

              <dx-button
                icon="undo"
                type="normal"
                [text]="'COMMON.RESTORE' | translate"
                [elementAttr]="{ 
                  class: 'active-button' 
                }"
                (onClick)="restoreProviderCategory(item)">
              </dx-button>
            </div>
          </div>
        </div>
      </div>
    </dx-scroll-view>

    <div class="popup-footer" *ngIf="isLoaded">
      @if(providers.length) {
        <div class="footer-note">
          <i 
            class="dx-icon dx-svg-icon" 
            [innerHTML]="getStarIcon()"
          ></i>
          {{ 'SUBSCRIPTION-SETTINGS.CALENDAR-VISIBILITY-INHERITED' | translate }}
        </div>

        <div class="footer-buttons">
          <dx-button
            [text]="'COMMON.CANCEL' | translate"
            type="default"
            (onClick)="close()"
          ></dx-button>

          <dx-button
            [text]="saveText"
            type="normal"
            (onClick)="onFormSubmit()"
          ></dx-button>
        </div>
      } @else {
        <div class="footer-buttons">
          <dx-button
            [text]="'COMMON.CLOSE' | translate"
            type="default"
            (onClick)="close()"
          ></dx-button>
        </div>
      }
    </div>
  </div>
</dx-popup>